<template>
  <div class="row">
    <div v-if="sets.length == 0">
      <b-spinner variant="primary" label="Spinning" style="margin-top: 100px;"></b-spinner>
    </div>

    <div class="col-12" v-if="sets.length > 0">
      <!-- MSG SETTINGS START -->
      <b-tabs
        content-class="mt-3"
        style="margin-top: 20px;"
        active-nav-item-class="font-weight-bold"
        v-model="actTab"
      >
        <b-tab title="+Add" key="addNewMsg" @click="AddNewMessageStart()"></b-tab>
        <b-tab
          v-for="(mset, mindex) in sets"
          :title="mset.title.length > 14 ? mset.title.substring(0, 14) + '..' : mset.title"
          @click="mSelected = Object.assign({}, mset)"
          :key="'remsg-' + mindex"
          :active="mSelected.msId == mset.msId"
        ></b-tab>
      </b-tabs>

      <div class="row">
        <div class="col m-color align-main-swithers">
          <div class="switchlabel">{{mSelected.title}} messaging turned on:</div>
          <b-form-checkbox v-model="mSelected.allowed" name switch style="display:inline;"></b-form-checkbox>
        </div>

        <div class="col-3" style="text-align: right;">
          <b-button
            type="button"
            variant="outline-danger"
            @click="RemoveMsgSettingStart()"
            size="sm"
            :disabled="sets.length == 1 || mSelected.type == 'confirmation'"
          >Remove</b-button>
          <!-- v-b-modal.remMsgConfirm -->
        </div>
      </div>
      <div class="row mt-2">
        <div class="col m-color align-main-swithers">
          <div class="switchlabel">Include Opt Out Customers:</div>
          <b-form-checkbox
            v-model="mSelected.ignoreContactAllowed"
            name
            switch
            style="display:inline;"
          ></b-form-checkbox>
        </div>
      </div>
      <div class="row">
        <div
          class="col align-main-swithers"
          style="font-size: 13px;"
        >{{mSelected.ignoreContactAllowed ? 'Message will be sent regardless of any customer contact requests' : 'Messaging will follow customer contact request'}}</div>
      </div>

      <div class="row msg-row">
        <div class="col-12 padd-0 triger-box-title m-color">Triggered:</div>
      </div>

      <div class="row">
        <div
          class="col-12"
          v-if="(mSelected.category == 'appointment' || mSelected.category == 'parts') && mSelected.type == 'confirmation'"
        >{{mSelected.category == 'appointment' ? 'Instant after appointment reflects in sheets' : mSelected.category == 'parts' ? 'Same day upon all parts available' : ''}}</div>
        <div class="col-6" v-else>
          <!-- <div class="row" v-if="mSelected.type == 'confirmation'">
            <div
              class="col-6 vertcenter tr-b-mt"
            >{{ mSelected.category == 'parts' ? 'Same day upon all parts available' : ''}}</div>
          </div>-->
          <!-- mSelected.category == 'appointment' ? 'Instant after appointment reflects in sheets' : -->
          <div class="row" v-if="mSelected.type != 'confirmation'">
            <!-- <div class="col-1"></div> -->
            <div class="col-3 vertcenter tr-main-styling">
              <b-form-input
                size="sm"
                type="number"
                v-model="mSelected.trigger"
                :disabled="!mSelected.allowed"
              ></b-form-input>
            </div>
            <div
              class="col-7 padd-0 vertcenter tr-add-styling"
            >Days {{mSelected.type != 'confirmation' ? 'From ' + mSelected.triggerName : ''}}</div>
          </div>
          <!-- <div class="row" v-if="mSelected.type != 'confirmation'">
            <div class="col-12 mt--7">From {{mSelected.triggerName}}</div>
          </div>-->
        </div>
        <!-- style="padding-top: 10px;align-self: center; text-align: left;" -->

        <!-- v-if="!(mSelected.category == 'appointment' && mSelected.type == 'confirmation')" -->
        <div class="col-6" v-if="!(mSelected.type == 'confirmation')">
          <div class="row" style="padding-top:5px;" v-if="valid(mSelected.ignoreReply)">
            <div class="col-8 padd-0 vertcenter tr-add-styling">
              <b-form-checkbox
                id="ignore-reply-checkbox"
                v-model="mSelected.ignoreReply.status"
                name="ignore_reply_param"
                :disabled="!mSelected.allowed"
                class="vertcenter"
              >Ignore If Last Reply Less than</b-form-checkbox>
            </div>
            <div class="col-2 padd-0 vertcenter" style="margin-top: 5px;">
              <b-form-input
                size="sm"
                type="number"
                v-model="mSelected.ignoreReply.days"
                :disabled="!mSelected.allowed || !mSelected.ignoreReply.status"
              ></b-form-input>
            </div>
            <div class="col-1 padd-0 vertcenter" style="margin-top: 5px;padding-left: 5px;">Days</div>
          </div>
        </div>

        <!-- <div class="col-8">
          <RemMsgContainer
            :msg_body="mSelected.msg_body"
            :assignedId="mSelected.category +'_msg_' + sets.findIndex(e => e.msId == mSelected.msId)"
            :allowed="mSelected.allowed"
            v-model="mSelected.msg_body"
            :key="sets.findIndex(e => e.msId == mSelected.msId)+'_msgbody'"
            :whitelistUpdate="wparams[mSelected.category]"
          />
        </div>-->
      </div>

      <!-- <div
        class="row"
        style="margin-top: 30px;"
        v-if="mSelected.category == 'appointment' || mSelected.category == 'marketing' || mSelected.category == 'parts'"
      >
        <div class="col-12">
          <div class="row m-color" style="margin-bottom: 10px;">
            <div
              class="col-8"
              style="font-weight: bold; text-align: left;"
            >Ignore sending this message IF:</div>
          </div>
          <div class="row" v-if="mSelected.category != 'parts'">
            <div
              class="col-7"
              style="font-weight: bold; text-align: left;"
            >Customer is on PartsList with Parts Ready</div>
            <div class="col" style="text-align: left;">
              <b-form-checkbox
                v-model="mSelected.ignoreIf.partsReady"
                name
                switch
                style="display:inline;"
                :disabled="!mSelected.allowed"
              ></b-form-checkbox>
            </div>
          </div>
          <div class="row" v-if="mSelected.category != 'parts'">
            <div
              class="col-7"
              style="font-weight: bold; text-align: left;"
            >Customer is on PartsList with Parts Not Ready</div>
            <div class="col" style="text-align: left;">
              <b-form-checkbox
                v-model="mSelected.ignoreIf.partsNotReady"
                name
                switch
                style="display:inline;"
                :disabled="!mSelected.allowed"
              ></b-form-checkbox>
            </div>
          </div>
          <div class="row" style="margin-top:10px;" v-if="mSelected.category != 'marketing'">
            <div class="col-7" style="font-weight: bold; text-align: left;">Customer is on CRS List</div>
            <div class="col" style="text-align: left;">
              <b-form-checkbox
                v-model="mSelected.ignoreIf.marketing"
                name
                switch
                style="display:inline;"
                :disabled="!mSelected.allowed"
              ></b-form-checkbox>
            </div>
          </div>

          <div class="row" style="margin-top:10px;" v-if="mSelected.category != 'appointment'">
            <div
              class="col-7"
              style="font-weight: bold; text-align: left;"
            >Customer has a scheduled appointment</div>
            <div class="col" style="text-align: left;">
              <b-form-checkbox
                v-model="mSelected.ignoreIf.appointment"
                name
                switch
                style="display:inline;"
                :disabled="!mSelected.allowed"
              ></b-form-checkbox>
            </div>
          </div>
        </div>
      </div>-->

      <div class="row" style="margin-bottom: 17px; margin-top: 20px;">
        <div class="col-12 padd-0">
          <div class="row">
            <div class="col-12 padd-0">
              <p class="m-color" style="text-align: left;">Message to Send:</p>
            </div>
          </div>
          <div
            class="row"
            v-for="msgbodyset in mSelected.msg_pool"
            :key="mSelected.msId + '_' + msgbodyset.trigger"
            style="margin-top: 10px;"
          >
            <div
              class="col-12"
              style="text-align: left;"
              v-if="msgbodyset.trigger == 'main' || mSelected.category != DefineCategoryByTrigger(mSelected.category, msgbodyset.trigger)"
            >
              <div class="row">
                <div class="col-12 padd-0">
                  <b-form-checkbox
                    v-model="msgbodyset.enabled"
                    name
                    style="display:inline;"
                    :disabled="!mSelected.allowed || msgbodyset.trigger == 'main'"
                  >{{msgBodyTitle(msgbodyset)}}</b-form-checkbox>
                </div>
              </div>

              <b-collapse
                :id="'collapse-msgbodysettings_' + mSelected.msId + '_' + msgbodyset.trigger"
                :visible="msgbodyset.enabled"
                style="margin-top: 13px;"
              >
                <div class="row">
                  <div class="col-10">
                    <b-form-radio-group
                      :id="'msgbodysettings_' + mSelected.msId + '_' + msgbodyset.trigger"
                      v-model="msgbodyset.ignore"
                      :options="[{text: 'Send following text', value: false}, {text: `Don't Send whole reminder`, value: true}]"
                      :disabled="!mSelected.allowed || msgbodyset.trigger == 'main'"
                    ></b-form-radio-group>
                  </div>

                  <div class="col-1"></div>
                  <div
                    class="col-1 padd-0 alignToRight"
                    v-if="msgbodyset.ignore == false"
                    :style="msgLengthStyle(msgbodyset.msg_body)"
                  >({{msgbodyset.msg_body.length || 0}})</div>
                </div>
              </b-collapse>

              <b-collapse
                :id="'collapse-msgbody_' + mSelected.msId + '_' + msgbodyset.trigger"
                :visible="msgbodyset.enabled && msgbodyset.ignore === false"
                class="mt-2"
              >
                <div class="row">
                  <div class="col-12">
                    <RemMsgContainer
                      :msg_body="msgbodyset.msg_body"
                      :assignedId="mSelected.category +'_msg_' + msgbodyset.trigger + '_' + sets.findIndex(e => e.msId == mSelected.msId)"
                      :allowed="mSelected.allowed && msgbodyset.enabled"
                      v-model="msgbodyset.msg_body"
                      :key="sets.findIndex(e => e.msId == mSelected.msId)+'_msgbody'+'_'+msgbodyset.trigger"
                      :whitelistUpdate="wordParamsPool(mSelected.category, msgbodyset.trigger)"
                    />
                  </div>
                </div>
              </b-collapse>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="row" style="margin-top: 10px;">
        <div class="col-12">
          <RemMsgContainer
            :msg_body="mSelected.msg_body"
            :assignedId="mSelected.category +'_msg_' + sets.findIndex(e => e.msId == mSelected.msId)"
            :allowed="mSelected.allowed"
            v-model="mSelected.msg_body"
            :key="sets.findIndex(e => e.msId == mSelected.msId)+'_msgbody'"
            :whitelistUpdate="wparams[mSelected.category]"
          />
        </div>
      </div>-->
      <!-- MSG SETTINGS END -->

      <!-- TIME TO SEND START -->
      <div
        class="row"
        style="margin-top: 20px;"
        v-if="valid(mSelected) && valid(mSelected.exec_time) && !(mSelected.category == 'appointment' && mSelected.type == 'confirmation')"
      >
        <div class="col-12 padd-0">
          <p style="text-align: left;" class="mb-5px m-color">Execution time:</p>
          <b-tabs content-class="mt-3" style="margin-top: 10px;">
            <b-tab
              v-for="(tab, tindex) in tabsPool"
              :key="tindex"
              :title="tab"
              :active="selectday == tindex"
              @click="selectday = tindex"
            ></b-tab>
          </b-tabs>

          <div class="row" style="margin-bottom: 20px;">
            <div class="col-6 padd-0 vertcenter">
              <SetTimeBox
                :key="selectday + '_' + mSelected.msId"
                v-model="mSelected.exec_time[selectday].time"
                title="Run at"
                :allowed="mSelected.exec_time[selectday].allowed && mSelected.allowed"
                addclass="aval-till-style"
              />
            </div>
            <div class="col-1"></div>
            <div
              class="col m-color"
              style="text-align: right;padding-left:0;"
            >{{tabsPool[selectday]}} Messaging turned on:</div>
            <div class="col-1" style="padding-left: 0;">
              <b-form-checkbox
                v-model="mSelected.exec_time[selectday].allowed"
                name
                switch
                size="lg"
                :disabled="!mSelected.allowed"
              ></b-form-checkbox>
            </div>
          </div>
        </div>
      </div>

      <div
        class="row addcampaignbtns"
        v-if="mSelected.category != 'appointment' && mSelected.category != 'marketing' && mSelected.category != 'parts'"
      >
        <div class="col-6">
          <b-button
            type="button"
            variant="outline-primary"
            size="sm"
            @click="UpdateCSV()"
          >Update CSV Data</b-button>
        </div>
        <div class="col-6">
          <b-button
            type="button"
            variant="outline-danger"
            @click="RemoveAllSettingsStart(mSelected.category)"
            size="sm"
          >Remove Campaign</b-button>
        </div>
      </div>

      <!-- TIME TO SEND END -->

      <b-modal
        id="newMsgAdd"
        title="Name message"
        @ok="AddNewMessage()"
        @hide="newMsgTitle = ''"
        :ok-disabled="newMsgTitle == ''"
      >
        <p class="mt-2">Enter this message settings name, please</p>
        <p>(e.g. "14Day Reminder")</p>
        <b-form-input type="text" v-model="newMsgTitle" />
      </b-modal>
      <b-modal
        id="remMsgConfirm"
        title="Please Confirm"
        size="sm"
        buttonSize="sm"
        okVariant="danger"
        okTitle="YES"
        cancelTitle="NO"
        footerClass="p-2"
        :hideHeaderClose="false"
        :centered="true"
        @ok="RemoveMsgSetting()"
      >
        <p style="color: darkred;">{{removeDetails.text}}</p>
        <p style="font-weight: bold;">Are you sure?</p>
      </b-modal>
    </div>
  </div>
</template>

<script>
import SetTimeBox from "../../additionalComponents/SetTimeBox.vue";
import RemMsgContainer from "./RemMsgContainer.vue";

export default {
  name: "RemSettingTab",
  components: {
    SetTimeBox,
    RemMsgContainer
  },
  props: {
    sets: Array,
    rem_set: Object,
    wparams: Object
  },
  data() {
    return {
      selectday: 0,
      selectMsg: 0,
      newMsgTitle: "",
      actTab: 1,
      tabsPool: ["Weekday/Business day", "Saturday", "Sunday/Days off"],

      allowChanges: true,

      mSelected: {},
      msIdSelected: "",
      newMsIdRemember: "",
      removeDetails: {
        all: null,
        text: ""
      }
    };
  },

  watch: {
    sets: {
      handler() {
        if (this.newMsIdRemember != "") {
          let ind = this.sets.findIndex(el => el.msId == this.newMsIdRemember);
          if (ind > -1) {
            this.mSelected = this.sets[ind];
            this.actTab = ind + 1;
          }
          this.newMsIdRemember = "";
        }
      },
      deep: true
    },
    mSelected: {
      handler() {
        if (
          this.msIdSelected != "" &&
          this.msIdSelected == this.mSelected.msId
        ) {
          this.$emit("settingsChanged", this.mSelected);
        }
        this.msIdSelected = this.mSelected.msId;
      },
      deep: true
    }
  },
  computed: {},

  mounted() {
    this.mSelected = this.sets[0];
  },

  methods: {
    wordParamsPool(category, cmpn) {
      let arr = Array.from(this.wparams[category]);

      let addKey = this.DefineCategoryByTrigger(category, cmpn);

      if (this.wparams[addKey] != undefined) {
        this.wparams[addKey].forEach(el => {
          if (!arr.find(e => e == el)) {
            arr.push(el);
          }
        });
      }

      return arr;
    },
    DefineCategoryByTrigger(category, cmpn) {
      return cmpn == "main"
        ? category
        : cmpn == "partsReady" || cmpn == "partsNotReady"
        ? "parts"
        : cmpn;
    },
    msgLengthStyle(msbody) {
      return {
        color:
          msbody.length < 170
            ? "darkgreen"
            : msbody.length < 300
            ? "goldenrod"
            : "red",
        fontSize: "12px"
      };
    },
    msgBodyTitle(msb) {
      let titleres = "";
      if (msb.trigger == "main") {
        titleres = "Default message (Customer is on no other list): ";
      } else if (msb.trigger == "appointment") {
        titleres = "Customer has an appointment scheduled: ";
      } else if (msb.trigger == "marketing") {
        titleres = "Customer is on CRS list: ";
      } else if (msb.trigger == "partsReady") {
        titleres = "Customer is on Parts list with Parts Ready: ";
      } else if (msb.trigger == "partsNotReady") {
        titleres = "Customer is on Parts list with Parts Not Ready: ";
      }
      return titleres;
    },
    UpdateCSV() {
      this.$bvModal.show("loadCSV");
    },
    RemoveAllSettingsStart() {
      let staticCats = ["appointment", "marketing", "parts"];
      if (staticCats.includes(this.mSelected.category)) {
        this.RemoveMsgSettingStart();
      } else {
        this.removeDetails = {
          all: true,
          text: `You are about to remove whole ${this.mSelected.category} campaign with all messaging settings and scheduled customer events!`
        };
        this.$bvModal.show("remMsgConfirm");
      }
    },
    RemoveMsgSettingStart() {
      this.removeDetails = {
        all: false,
        text: `You are about to remove messaging settings for "${this.mSelected.title}"`
      };
      this.$bvModal.show("remMsgConfirm");
    },
    RemoveMsgSetting() {
      let ar = [];
      if (this.removeDetails.all === true) {
        this.$emit("removeCategoryUsr", this.mSelected.category);
        ar = this.sets.filter(el => el.category == this.mSelected.category);
      } else {
        ar = [this.mSelected];
      }

      ar.forEach(a => {
        this.$emit("removeSetting", a.msId);
      });
    },
    AddNewMessageStart() {
      this.$bvModal.show("newMsgAdd");
      this.$nextTick(() => {
        this.actTab =
          this.sets.findIndex(el => el.msId == this.mSelected.msId) + 1;
      });
    },
    AddNewMessage() {
      this.newMsIdRemember = this.uigen();
      this.$emit("addMsSetting", {
        title: this.newMsgTitle,
        msId: this.newMsIdRemember,
        category: this.sets[0].category,
        triggerName: this.sets[0].triggerName
      });
    },

    MsgInputBoxStyling(val) {
      let bx = this.$el.querySelector(".tagify");
      if (val) {
        bx.classList.remove("tgf-disable-input");
      } else {
        bx.classList.add("tgf-disable-input");
      }
      bx.querySelector(".tagify__input").setAttribute("contenteditable", val);
    },

    msgFromInput() {
      this.$emit(
        "input",
        this.FormatMsgInput(this.$el.querySelector(`#${this.assignedId}`).value)
      );
    },

    FormatMsgInput(ss) {
      const matcherFix = new RegExp(/\[\[\{(.*?)\}\]\]/, "gm");
      const sliceFix = str => str.slice(2, -2);

      if (ss.match(matcherFix) != null) {
        let rs = ss.match(matcherFix).map(sliceFix);
        for (let i in rs) {
          ss = JSON.parse(rs[i]).value
            ? ss.replace(rs[i], `${JSON.parse(rs[i]).value}`)
            : ss;
        }
      }
      return ss;
    },
    uigen() {
      return (
        "t" +
        Math.random()
          .toString(36)
          .substr(2, 9) +
        `${Date.now()}`
      );
    },
    CountTill100() {
      let r = [];
      for (let i = 1; i < 100; i++) {
        r.push(i);
      }
      return r;
    },
    valid(val) {
      return val != undefined && val != null && val !== "";
    }
  }
};
</script>
<style>
.addcampaignbtns {
  border-top: 1px solid lightblue;
  padding-top: 20px;
}
.tagify {
  min-height: 86px;
}
.padd-0 {
  padding: 0;
}
.m-color {
  color: #266db3;
}
#lfcycle select {
  line-height: 1;
  font-size: 14px;
  padding-top: 0;
  padding-bottom: 0;
  height: 28px;
}
.vertcenter {
  align-self: center;
}
.switchlabel {
  text-align: left;
  /* width: fit-content; */
  display: inline;
  padding-right: 10px;
}
.msg-row {
  margin-bottom: 17px;
  margin-top: 20px;
}
.triger-box-title {
  text-align: left;
}
.tr-b-mt {
  margin-top: 10px;
}
.tr-main-styling {
  margin-top: 10px;
  text-align: right;
  padding-right: 10px;
}
.tr-add-styling {
  margin-top: 10px;
  text-align: left;
}
.mt--7 {
  margin-top: 7px;
}
.font-weight-bold {
  font-weight: bold;
}
.alignToRight {
  text-align: right;
}
</style>





